export const eventTraceConfig = domain => ({
  searchLabel: "Search events", quickFilter: { key: "direction", label: "Direction", icon: "direction", values: ["IN", "OUT"] },
  cards: [{ value: "ALL", label: "All" }, ...["Quarantined", "Retry", "Failed"].map(value => ({ value, label: value }))],
  filters: [
    { key: "status", label: "Status", icon: "status", values: ["Received", "Processing", "Retry", "Quarantined", "Failed", "Unused", "Completed"] },
    { key: "stage", label: "Stage", icon: "stage", values: ["Global Event", "Tenant Targeting", "Dispatcher", "Punch Entry", "Attendance"] },
    { key: "device", type: "device", label: "Device", icon: "device" },
    { key: "event_time", type: "date", label: "Event time", icon: "time", quick: true },
    { key: "received_at", type: "date", label: "Received time", icon: "received" },
  ], labels: { event_time: "Event time", status: "Status", stage: "Stage", device: "Device", direction: "Direction", search: "Search", received_at_from: "Received from", received_at_to: "Received to", event_time_from: "Event from", event_time_to: "Event to" },
  deviceEndpoint: `${domain}monitoring/event-trace/device-options/`,
  sortOptions: [
    { value: "event_time", label: "Time", icon: "time" },
    { value: "employee_name", label: "Employee", icon: "employee" },
    { value: "device_name", label: "Device", icon: "device" },
    { value: "status", label: "Status", icon: "status" },
  ],
});

export const eventTraceSortKeys = { eventTime: "event_time", employee: "employee_name", device: "device_name", status: "status" };
export const eventTraceQueryAliases = { start_date: "received_at_from", end_date: "received_at_to" };

export const eventTraceDateField = state => state.event_time === "all" &&
  !state.event_time_from && !state.event_time_to &&
  (state.received_at_from || state.received_at_to || state.start_date || state.end_date)
  ? "received_at" : "event_time";
